// `GET /prospects/by-phone?phone=` — el prospecto abierto que ese teléfono ya tiene en la tienda.
import { isPendingReason } from '@/domains/sales/wizard/prospects';
import type { ProspectByPhone } from '@/domains/sales/wizard/types';

/** TD-F2-WIZ-001: espejo a mano de `RetailWizard.ProspectByPhoneResponse` (type-kit 3.323.0). */
export interface ProspectByPhoneWire {
    found: boolean;
    customerName: string | null;
    pendingReason: string | null;
    freeReason: string | null;
    nextContactAt: string | null;
    notes: string | null;
}

const NO_PROSPECT: ProspectByPhone = {
    found: false,
    customerName: null,
    pendingReason: null,
    freeReason: null,
    nextContactAt: null,
    notes: null,
};

/**
 * Respuesta del cable → lo que el drawer precarga. `found` manda: sin prospecto, cerrado, perdido
 * o de otra tienda llegan iguales, y los tres son el caso normal, no un error.
 */
export function toProspectByPhone(wire: ProspectByPhoneWire): ProspectByPhone {
    if (!wire.found) return NO_PROSPECT;
    return {
        found: true,
        customerName: wire.customerName,
        // Un motivo que el silo agregue antes que el front dejaría al `Select` con un valor sin
        // etiqueta: se descarta y el vendedor elige, en vez de perder toda la precarga.
        pendingReason:
            wire.pendingReason && isPendingReason(wire.pendingReason) ? wire.pendingReason : null,
        freeReason: wire.freeReason,
        nextContactAt: wire.nextContactAt,
        notes: wire.notes,
    };
}
